import React, { ComponentProps } from "react";
import { makeClassName } from "../util";

const Label : React.FC<ComponentProps<"label">> = ({className, children, ...props}) =>
    <label className={makeClassName(className, ["jobjump-label"])} {...props}>
        <strong>{children}</strong>
    </label>

export default Label;